





















































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import VueSeamlessStore from '@seamless/vue-store-plugin';
import { SeamlessCoreStore } from '@seamless/store';
import { Logger } from '@b2x/common';
import { AuthDispatchersCias, AUTHENTICATION_CONNECTION_CIAS, Claims } from '@b2x/login-library';

import { UserMenuConfig } from '@/common/interfaces/common';
import LinkList from '@/components/link-list.vue';

@Component({
  name: 'user-flyout',
  mixins: [new VueSeamlessStore().mixin],
  components: {
    LinkList,
  },
})
export default class UserFlyout extends Vue {
  store!: SeamlessCoreStore;

  @Prop()
  config!: UserMenuConfig | null;

  @Prop()
  claims!: Claims | null;

  logger = new Logger('USER_MENU_FLYOUT');

  ciasDispatchers!: AuthDispatchersCias;

  async created(): Promise<void> {
    this.logger.log('user flyout created');

    this.ciasDispatchers = await this.store.getConnectionDispatchers(AUTHENTICATION_CONNECTION_CIAS);
  }

  onLoginAction(): void {
    this.logger.log('Login action triggered');

    this.ciasDispatchers.login();
  }

  onLogoutAction(): void {
    this.logger.log('Logout action triggered');

    this.ciasDispatchers.logout();
  }

  onRegisterAction(): void {
    this.logger.log('Register action triggered');
  }
}
